import { render, staticRenderFns } from "./ComposableProduct.vue?vue&type=template&id=48d6936e&scoped=true&"
import script from "./ComposableProduct.vue?vue&type=script&lang=js&"
export * from "./ComposableProduct.vue?vue&type=script&lang=js&"
import style0 from "./ComposableProduct.vue?vue&type=style&index=0&id=48d6936e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6936e",
  null
  
)

export default component.exports